import BtnInMobileNavBar from "./modules/btnInMobileNavBar";
import MobileSlider from "./modules/mobileSlider";
import CustomizableSwiper from "./modules/customizableSlider";

const btnInMobileNavBar = new BtnInMobileNavBar();
const customDescriptionSlider = new MobileSlider(
    '.js-company-slider',
    '.js-company-slider-slides'
);
const descriptionSlider = new CustomizableSwiper(
    '.js-description-slider',
    {
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        preloadImages: false,
        effect: (window.innerWidth <= 715) ? "cards" : "fade",
        fadeEffect: {
            crossFade: false
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: true
        }
    }
);
